import { HttpStatusCode } from '@angular/common/http';

export const GRAPHQL_ERROR_MESSAGES: { type: string; message: string | ((message?: string) => string) }[] = [
  {
    type: 'AUTH_NOT_AUTHENTICATED',
    message: 'U bent niet ingelogd',
  },
  {
    type: 'AUTH_NOT_AUTHORIZED',
    message: 'U heeft onvoldoende rechten',
  },
  { type: 'AGENT_NOT_EMPTY', message: 'Organisatie kan niet worden verwijderd omdat het niet leeg is' },
  { type: 'AGENT_NOT_FOUND', message: 'De organisatie is niet gevonden.' },
  { type: 'ALARM_NOT_FOUND', message: 'Het alarm is niet gevonden.' },
  { type: 'ALERT_NOT_FOUND', message: 'Het alert is niet gevonden.' },
  { type: 'ASSET_DEFINITION_NOT_FOUND', message: 'De apparaatdefinitie is niet gevonden.' },
  { type: 'ASSET_NOT_FOUND', message: 'Het apparaat is niet gevonden.' },
  { type: 'BUILDING_NOT_FOUND', message: 'Het gebouw is niet gevonden.' },
  { type: 'OBJECT_NOT_FOUND', message: 'Het object is niet gevonden.' },
  { type: 'OBJECT_NOT_VALID', message: 'Het object is niet geldig.' },
  { type: 'OBJECT_TYPE_IN_CORRECT', message: 'Het objecttype is niet correct.' },
  { type: 'APPLICATION_NOT_FOUND', message: 'De applicatie is niet gevonden.' },
  { type: 'TOO_MANY_APPLICATIONS', message: 'Er zijn te veel applicaties aangemaakt.' },
  { type: 'FEATURE_ALREADY_SET', message: 'Deze feature is al ingesteld.' },
  { type: 'FEATURE_NOT_FOUND', message: 'De feature is niet gevonden.' },
  { type: 'INTEGRATION_NOT_CONFIGURED', message: 'De integratie is niet geconfigureerd.' },
  { type: 'INTEGRATION_NOT_FOUND', message: 'De integratie is niet gevonden.' },
  { type: 'ORGANIZATION_NOT_FOUND', message: 'De organisatie is niet gevonden.' },
  { type: 'POINT_NOT_FOUND', message: 'Het meetpunt is niet gevonden.' },
  { type: 'SPACE_NOT_FOUND', message: 'De ruimte is niet gevonden.' },
  { type: 'TARGET_NOT_FOUND', message: 'Het doel is niet gevonden.' },
  { type: 'TWIN_NOT_FOUND', message: 'De twin is niet gevonden.' },
  {
    type: 'APPLICATION_USER_GLOBAL_ROLE_NOT_FOUND',
    message: 'De globale rol van de applicatiegebruiker is niet gevonden.',
  },
  { type: 'APPLICATION_USER_NOT_FOUND', message: 'De applicatiegebruiker is niet gevonden.' },
  { type: 'TENANT_USER_NOT_IN_ORGANIZATION', message: 'De gebruiker behoort niet tot de organisatie.' },
  { type: 'UTILITY_CONTRACT_OVERLAPS', message: 'Er is een overlap in de utility contracten.' },
  { type: 'UTILITY_CONTRACT_NOT_FOUND', message: 'Het utility contract is niet gevonden.' },
  { type: 'COST', message: 'Er is een fout opgetreden bij het berekenen van de kosten.' },
  { type: 'CATEGORY_HAS_CHILDREN', message: 'Categorie heeft subcategorieën.' },
  { type: 'CATEGORY_IN_USE', message: 'Categorie is in gebruik en kan niet worden verwijderd.' },
  {
    type: 'HC0045',
    message: 'Time-out',
  },
  {
    type: 'POWER_SENSOR_NOT_FOUND',
    message: 'De meter ondersteund het niet om het vermogen te meten.',
  },
  {
    type: 'TIME_SLICE_NOT_SUPPORTED',
    message: 'De gekozen tijdsinterval wordt niet ondersteund voor alle grafieken.',
  },
  {
    type: 'COMPARISON_NOT_SUPPORTED',
    message: 'Vergelijken wordt niet ondersteund voor alle grafieken.',
  },
  {
    type: 'INSUFFICIENT_DATA',
    message: 'Er is onvoldoende data beschikbaar.',
  },
  {
    type: 'INTEGRATION_ALREADY_EXISTS',
    message: 'Er bestaat al een integratie voor de organisatie',
  },
  {
    type: 'INSUFFICIENT_MEASURING_DATA',
    message: 'Er is onvoldoende meetdata beschikbaar voor de geselecteerde objecten.',
  },
  {
    type: 'BAG',
    message: (message): string => {
      switch (message) {
        case 'Building data API not reachable':
        case 'Building data API error':
          return 'Er is een fout opgetreden bij het ophalen van adresgegevens. Probeer het later opnieuw.';
        case 'Bad address':
          return 'Het opgegeven adres is niet gevonden.';
        default:
          return 'Er is een fout opgetreden bij het ophalen van adresgegevens.';
      }
    },
  },
  {
    type: 'REQUEST',
    message: 'Er is een fout opgetreden bij het versturen van het verzoek.',
  },
  {
    type: 'ALERT_ALREADY_RESOLVED',
    message: 'Het alert is al onderdrukt.',
  },
];

export const HTTP_ERROR_MESSAGES: { code: HttpStatusCode; message: string }[] = [
  {
    code: HttpStatusCode.BadRequest,
    message: 'Verzoek naar de server is niet goed',
  },
  {
    code: HttpStatusCode.Unauthorized,
    message: 'U bent niet ingelogd',
  },
  {
    code: HttpStatusCode.Forbidden,
    message: 'U heeft onvoldoende rechten',
  },
  {
    code: HttpStatusCode.TooManyRequests,
    message: 'Te veel verzoeken naar de server',
  },
];

export const PATH_ERROR_MESSAGES: IPathErrorMessage[] = [];

export const OBJECT_DICTIONARY: Record<string, string> = {
  asset: 'het apparaat',
  assets: 'de apparaten',
  space: 'de ruimte',
  spaces: 'de ruimte',
  organizations: 'de organisaties',
  integrations: 'de integratie',
  buildings: 'het gebouw',
  building: 'het gebouw',
};

export const ACTION_DICTIONARY: Record<string, string> = {
  remove: 'verwijderen',
  delete: 'verwijderen',
  update: 'bewerken',
  create: 'aanmaken',
  acknowledge: 'bevestigen',
  add: 'toevoegen',
  export: 'exporteren',
  move: 'verplaatsen',
  read: 'lezen',
};

export function generatePathErrorMessage(error: IPathErrorMessage): string {
  return error.custom ? error.custom : `Fout bij het ${error.action ?? 'ophalen'} van ${error.name ?? 'de data'}.`;
}

interface IPathErrorMessage {
  path: string[];
  action?: string;
  name?: string;
  custom?: string;
}
